require('./segment.js');
module.exports = 'ngSegment';
